import React from 'react';

export default function Background() {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Moon */}
      <div className="absolute top-32 left-32 w-24 h-24 bg-cyan-300 rounded-full opacity-80 shadow-lg shadow-cyan-400/50"></div>
      
      {/* Stars */}
      <div className="absolute top-40 left-1/4 w-1 h-1 bg-white rounded-full opacity-75"></div>
      <div className="absolute top-60 right-1/3 w-1 h-1 bg-white rounded-full opacity-75"></div>
      <div className="absolute top-96 left-1/3 w-1 h-1 bg-white rounded-full opacity-75"></div>
      
      {/* Mountains Background */}
      <svg className="absolute bottom-0 w-full" viewBox="0 0 1440 400" preserveAspectRatio="none">
        {/* Back mountains */}
        <path d="M0,200 L200,100 L400,150 L600,80 L800,120 L1000,90 L1200,140 L1440,100 L1440,400 L0,400 Z" 
              fill="rgba(30, 58, 138, 0.6)" />
        {/* Mid mountains */}
        <path d="M0,250 L150,180 L350,220 L550,160 L750,200 L950,170 L1150,210 L1440,180 L1440,400 L0,400 Z" 
              fill="rgba(30, 58, 138, 0.8)" />
        {/* Front mountains */}
        <path d="M0,300 L100,240 L300,280 L500,220 L700,260 L900,230 L1100,270 L1440,240 L1440,400 L0,400 Z" 
              fill="rgba(30, 64, 175, 0.9)" />
        
        {/* Houses */}
        <rect x="100" y="340" width="15" height="20" fill="#FCD34D" opacity="0.8" />
        <polygon points="107.5,335 100,340 115,340" fill="#FCA5A5" opacity="0.8" />
        
        <rect x="1400" y="345" width="12" height="15" fill="#FCD34D" opacity="0.8" />
        <polygon points="1406,342 1400,345 1412,345" fill="#FCA5A5" opacity="0.8" />
      </svg>
    </div>
  );
}